export const calculateEmployeeW2 = (payload, taxInformationData) => {
  const nextPayload = { ...payload };

  const grossPay = parseFloat(nextPayload["Gross Monthly Wages"] || 0);
  const overtimeTips = parseFloat(nextPayload["Qualified Overtime/Tips"] || 0);
  const totalGross = grossPay + overtimeTips;

  let fedTax = parseFloat(nextPayload["Federal Taxes"] || 0);
  let stateTax = parseFloat(nextPayload["State Taxes"] || 0);

  // Apply global tax fallbacks if no specific taxes are entered
  if (fedTax === 0 && totalGross > 0 && taxInformationData) {
    const fedRate = parseFloat(taxInformationData["Federal Tax Rate"] || 0) / 100;
    fedTax = parseFloat((totalGross * fedRate).toFixed(2));
    nextPayload["Federal Taxes"] = fedTax;
  }
  if (stateTax === 0 && totalGross > 0 && taxInformationData) {
    const stateRate = parseFloat(taxInformationData["State Tax Effective Rate"] || 0) / 100;
    stateTax = parseFloat((totalGross * stateRate).toFixed(2));
    nextPayload["State Taxes"] = stateTax;
  }

  const retirementContrib = parseFloat(nextPayload["Employment Retirement Contributions"] || 0);
  const ssTax = parseFloat(nextPayload["Social Security Tax"] || 0);
  const medicareTax = parseFloat(nextPayload["Medicare Tax"] || 0);
  const localTax = parseFloat(nextPayload["Local Income Tax"] || 0);
  const disability = parseFloat(nextPayload["Disability / PFL"] || 0);
  const rothContrib = parseFloat(nextPayload["Designated Roth Contributions"] || 0);
  const hsaContrib = parseFloat(nextPayload["HSA Contributions"] || 0);
  
  // Health Insurance field may be present in broader schema, defaulting to 0 if missing
  const healthInsurance = parseFloat(nextPayload["Health Insurance Premiums"] || 0);

  // Formula as per client: Amount Subject to Federal Taxation = Gross Pay - Pre-tax Retirement - HSA - Health Insurance
  // Note: We use Gross Pay (Per Period) as the base here as per doc instruction.
  const amountSubjectToTax = grossPay - retirementContrib - hsaContrib - healthInsurance;
  nextPayload["Amount Subject to Federal Taxation"] = parseFloat(amountSubjectToTax.toFixed(2));

  // Net Take-Home Pay = Total Gross - sum of all taxes and contributions
  const totalDeductions = 
    fedTax + 
    stateTax + 
    ssTax + 
    medicareTax + 
    localTax + 
    disability + 
    retirementContrib + 
    hsaContrib + 
    rothContrib + 
    healthInsurance;

  const netAmount = totalGross - totalDeductions;
  nextPayload["Net Amount"] = parseFloat(netAmount.toFixed(2));

  return nextPayload;
};

export const getEmployeeW2Config = (name) => {
  const config = {
    "Gross Monthly Wages": { label: "Gross Pay (Per Period)" },
    "Qualified Overtime/Tips": { label: "Qualified Overtime/Tips" },
    "Type of Employment Income": { delete: true },
    "Adjusted Gross Income (AGI) Toggle": { delete: true },
    "Adjusted Gross Income (AGI)": { delete: true },
    "Passive or Active": { delete: true },
    "Amount Subject to Federal Taxation": { label: "Amount Subject to Federal Taxation", readOnly: true },
    "Net Amount": { label: "Net Take-Home Pay", readOnly: true },
    "Employment Retirement Contributions": { label: "401(k) / 403(b) Deferrals" },
    "Designated Roth Contributions": { label: "Designated Roth Contributions" },
    "Social Security Tax": { label: "Social Security Tax" },
    "Medicare Tax": { label: "Medicare Tax" },
    "Local Income Tax": { label: "Local Income Tax" },
    "Disability / PFL": { label: "Disability / PFL" },
    "HSA Contributions": { label: "HSA Contributions" },
    "Independent Contractor Income Section": { delete: true }, // Redundant grouped section for W2
  };
  return config[name] || {};
};

export const getEmployeeW2GroupPrefix = (groupName, formGroupName) => {
  if (formGroupName === "W2 Income Section") return "Part B: ";
  if (groupName === "TAXATION") return "Part C: ";
  return "";
};
